<template>
  <div class="network-box">
    <div class="network-ul">
      <div class="network-li" v-for="(item,index) in network" :key="index">
        <div class="network-top">
          {{item.centerName}}
        </div>
        <div class="network-bottom">
          <div class="network-text">{{item.intro}}</div>
          <div class="network-bt" @click="onClickRoute(item)">查看详情<img src="@/assets/images/go.png"/></div>
        </div>
      </div>
    </div>
    <el-pagination v-if="page.number != undefined" class="paging" background :current-page="page.number" :page-sizes="[6, 10, 20, 30]" :page-size="page.limit" layout="prev, pager, next, sizes" :total="page.total" @size-change="sizeChange"
      @current-change="currentChange" @prev-click="prevClick" @next-click="nextClick"></el-pagination>
  </div>
</template>

<script>
export default {
  name: "index",
  props: {
    // 定义 guide 为数组类型，必填
    network: {
      type: Array,
      required: true,
      default: () => [] // 防止 undefined
    },
    page: {
      type: Object,
      default: () => {
        return {}
      }
    },
    activeIndex: {
      type: String,
      default: '',
    }
  },
  data() {
    return {

    };
  },
  methods: {
    onClickRoute(value) {
      let token = localStorage.getItem("x-token")
      if(token == null) {
        this.$router.push({ path: `/codeLogin` });
        return
      }
      this.$router.push({ path: `/QualityControlDetails/${value.id}?type=1` }); // 动态路由传递课程 id
    },
    sizeChange(value) {
      this.$emit('sizeChange', value)
    },
    currentChange(value) {
      this.$emit('currentChange', value)
    },
    prevClick(value) {
      this.$emit('currentChange', value)
    },
    nextClick(value) {
      this.$emit('currentChange', value)
    },
  },
  mounted() {

  }
};
</script>

<style scoped lang="less">
.qualityControl-box {
  .paging{
    display: block;
  }
  .network-ul{
    .network-li {
      width: calc(33.3% - 13px);
    }
  }
}
.network-ul{
  display: flex;
  flex-wrap: wrap;
  // justify-content: space-between;
  gap: 10px;

  .network-li{
    width: calc(50% - 10px);
    margin-top: 16px;
    border: 1px solid rgba(212, 212, 212, 1);
    position: relative;
    .network-top{
      line-height: 40px;
      height: 40px;
      background: rgba(164, 18, 24, 1);
      color: #fff;
      font-size: 20px;
      font-weight: bold;
    }
    .network-bottom{
      padding: 20px 0;
      padding-bottom: 60px;
      .network-text{
        color: rgba(38, 38, 38, 1);
        font-size: 16px;
        line-height: 28px;
        width: 260px;
        margin: auto;
        display: -webkit-box;             /* 必须设置，用于多行溢出 */
        -webkit-box-orient: vertical;     /* 设置盒子排列方向为垂直 */
        -webkit-line-clamp: 2 ;            /* 限制显示的行数，例如显示 3 行 */
        overflow: hidden;                 /* 隐藏超出的内容 */
      }
      .network-bt{
        display: flex;
        align-items: center;
        justify-content: center;
        color: rgba(115, 115, 115, 1);
        font-size: 16px;
        cursor: pointer;
        margin-top: 26px;
        position: absolute;
        bottom: 20px;
        left: calc(50% - 43px);
        img{
          width: 16px;
          margin-left: 6px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/network/index.vue